import CarPartGroupsSection from './CarPartGroupsSection';

export default CarPartGroupsSection;
